import { PurchaseOrderStatus } from '../constants/purchase-order-status.js';
/** Statuses that allow a dateFirstShip-only header edit. GraphQL `where` clauses use this list. */
export const PURCHASE_ORDER_EXPECTED_DELIVERY_EDITABLE_STATUS_IDS = [
    PurchaseOrderStatus.DRAFT,
    PurchaseOrderStatus.ISSUED,
    PurchaseOrderStatus.SHIPPED,
    PurchaseOrderStatus.PARTIALLY_RECEIVED,
];
//# sourceMappingURL=purchase-order-expected-delivery-editable-status-ids.js.map